<template>

  <el-dialog title="添加" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" :label-width="formLabelWidth">
      <el-form-item label="等级">
        <el-select v-model="form.grade_id" placeholder="请选择">
          <el-option v-for="(item, index) in gradeList" :key="index" :label="item.name" :value="item.grade_id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态：">
        <el-radio-group v-model="form.status">
          <el-radio :label="0">关闭</el-radio>
          <el-radio :label="1">开启</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="设置类型：">
        <el-radio-group v-model="form.type">
          <el-radio :label="0">统一设置</el-radio>
          <el-radio :label="1">独立设置</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="奖励：" prop="award" v-if="form.type==0">
        <el-input v-model="form.award" type="number" :min="0" :max="100" :step="1" placeholder="请输入比例" class="max-w460">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>
      <el-form-item label="奖励：" v-if="form.type==1">
        <div  class="max-w460">
          <el-table :data="gradeList" border size="mini" style="width: 100%">
            <el-table-column prop="name" label="会员等级" width="200"></el-table-column>
            <el-table-column
              prop="name"
              label="奖励">
              <template v-slot="scope">
                <div class="d-s-c">
                  <el-input v-model="scope.row.award" type="number" :min="0" :max="100" :step="1" placeholder="请输入奖励"></el-input>
                  <span class="ml10">元</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form-item>

    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import GroupawardApi from '@/api/groupaward.js';
export default {
  data() {
    return {
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      loading: false,
      /*是否显示*/
      dialogVisible: false,
      award: 0,
    };
  },
  props: ['open','form','gradeList'],
  watch: {
    open: function(n, o) {
      if (n != o) {
        this.dialogVisible = this.open;
      }
    },
  },
  created() {},
  methods: {
    /*转JSON字符串*/
    convertJson(list) {
      let obj = {};

      list.forEach(item => {
        if(item.award){
          obj[item.grade_id] = item.award;
        } else {
          obj[item.grade_id] = 0;
        }
      });

      return JSON.stringify(obj);
    },

    /*添加*/
    onSubmit() {
      let self = this;
      self.loading = true;
      let params = self.form;
      params.award_detail = self.convertJson(self.gradeList);

      GroupawardApi.add(params, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: '恭喜你，添加成功',
            type: 'success'
          });
          self.dialogFormVisible(true);
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit('close', {
          type: 'success',
          openDialog: false
        });
      } else {
        this.$emit('close', {
          type: 'error',
          openDialog: false
        });
      }
    },

  }
};
</script>

<style>
  .w150{
    width: 150px;
    border-collapse: collapse;
  }
  .tc{
    text-align: center;
    border-collapse: collapse;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/groupaward/groupaward/dialog/Add.vue